import React, { useMemo } from 'react'
import { List, ListItem } from '@fs/zion-ui'
import getFormattedDate, { dateFormats } from '../../../../../../../shared/utils/dateFormatHelper'
import transl from './ReworkFolder.transl'

export default function ReworkHistoryItems({ reworkHistory = [] }) {
  const reworkHistoryItems = useMemo(() => {
    return reworkHistory?.reduce((acc, current) => {
      const { date, state, username, notes, action } = current
      const formattedDate = getFormattedDate(date.fromTimestamp, date.toTimestamp, dateFormats.formatted)
      let resolvedState = state
      if (state === 'Available')
        if (action === 'CameraRework') resolvedState = transl.approved()
        else resolvedState = transl.requested

      if (acc.length < 1)
        return [{ date: formattedDate, items: [{ state: resolvedState, username, notes, key: date.fromTimestamp }] }]

      const lastItem = acc[acc.length - 1]
      if (lastItem.date === formattedDate) {
        lastItem.items.push({ state: resolvedState, username, notes, key: date.fromTimestamp })
        return acc
      }
      return [
        ...acc,
        { date: formattedDate, items: [{ state: resolvedState, username, notes, key: date.fromTimestamp }] },
      ]
    }, [])
  }, [reworkHistory])

  return (
    <>
      {reworkHistoryItems.map(({ date, items }) => (
        <React.Fragment key={date}>
          <strong>{date}</strong>
          <List>
            {items?.map((i) => (
              <ListItem key={i.key} primaryText={i?.state} secondaryText={i?.notes} overline={i?.username} />
            ))}
          </List>
        </React.Fragment>
      ))}
    </>
  )
}
